<template>
  <div v-if="after2025">
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="560px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5"></h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <h2 class="main-heading">
            Help those you care about protect their legacy.
          </h2>
          <p>
            You’ve done it — your will is complete. Now, help your friends and
            family do the same. A simple nudge from you could be all that is
            needed to help them to get it done.
          </p>
          <div class="refer-friend-image">
            <v-img :src="whitelabel.images.referAFriendImage" />
          </div>

          <div class="body-text">
            <p class="bold-text">It’s easy to refer:</p>
            <ul class="mt-3 mb-3">
              <li>Share your unique link via WhatsApp or email, or</li>
              <li>
                Add their details in your dashboard — we’ll handle the rest.
              </li>
            </ul>
            <p class="bold-text mb-0">Don’t leave them in the dark.</p>
            <p class="mt-0">Give them the peace of mind you now have.</p>
          </div>

          <div class="button-container">
            <GradientButton
              :title="'Go to referrals page'"
              :small="false"
              @gradientButtonClicked="goToReferrals"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="560px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5"></h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <h2 class="main-heading">
            Help those you care about protect their legacy,
            <span style="font-weight: 400"
              >and receive a R500 Takealot Voucher</span
            >
          </h2>
          <p>
            You’ve done it — your will is complete. Now, help your friends and
            family do the same. A simple nudge from you could be all that is
            needed to help them to get it done.
          </p>
          <p>
            And as a thank you,
            <strong
              >you’ll receive a R500 Takealot Voucher when the person you refer
              completes and validates their will between 1 and 31 October 2025.
              *</strong
            >
          </p>
          <div class="refer-friend-image">
            <v-img :src="whitelabel.images.referAFriendImage" />
          </div>

          <div class="body-text">
            <p class="bold-text">It’s easy to refer:</p>
            <ul class="mt-3 mb-3">
              <li>Share your unique link via WhatsApp or email, or</li>
              <li>
                Add their details in your dashboard — we’ll handle the rest.
              </li>
            </ul>
            <p class="bold-text mb-0">Don’t leave them in the dark.</p>
            <p class="mt-0">
              Give them the peace of mind you now have — and enjoy a little
              something extra for helping.
            </p>

            <p class="terms-and-conditions">
              <a
                href="/pdfs/Referrals-Incentive-Terms-and-Conditions.pdf"
                download="Referrals-Incentive-Terms-and-Conditions.pdf"
                >*Terms and Conditions apply.</a
              >
            </p>
          </div>

          <div class="button-container">
            <GradientButton
              :title="'Go to referrals page'"
              :small="false"
              @gradientButtonClicked="goToReferrals"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mdiClose } from '@mdi/js';

  export default {
    name: 'ReferralPopupDialogue',
    props: {
      value: { type: Boolean },
    },
    data() {
      return {
        icons: {
          mdiClose: mdiClose,
        },
      };
    },
    computed: {
      show: {
        get() {
          const hasBeenDismissed = localStorage.getItem(
            'referralPopupDismissed'
          );
          if (hasBeenDismissed === 'true') {
            return false;
          }
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      after2025() {
        const today = new Date();
        return today.getFullYear() > 2025;
      },
    },
    methods: {
      goToReferrals() {
        localStorage.setItem('referralPopupDismissed', 'true');
        this.$router.push({ name: 'Referrals' });
        this.closeDialog();
      },
      closeDialog() {
        localStorage.setItem('referralPopupDismissed', 'true');
        this.show = false;
      },
    },
  };
</script>

<style scoped lang="scss">
  .terms-and-conditions {
    margin-top: 36px;
    a {
      text-decoration: none;
    }
  }
  .crud-dialog {
    .crud-card {
      .crud-card-title {
        padding: 24px 24px 0 24px;

        .close {
          cursor: pointer;
          font-size: 24px;
        }

        h2 {
          font-size: 20px;
          font-weight: 600;
          line-height: 24px;
          color: #333;
          margin: 0;
        }
      }

      .crud-card-text {
        padding: 24px;

        .main-heading {
          font-size: 24px;
          font-weight: 700;
          line-height: 31.2px;
          margin-bottom: 24px;
          color: #333;
        }

        .refer-friend-image {
          margin-bottom: 24px;

          .v-image {
            border-radius: 8px;
            overflow: hidden;
          }
        }

        .body-text {
          margin-bottom: 32px;

          p {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            margin-bottom: 12px;
            color: #333;

            &.bold-text {
              font-weight: 600;
            }
          }
        }

        .button-container {
          text-align: center;
        }
      }
    }
  }
</style>
